import { GetProjectApiResponse, ProjectModel } from 'store/userOrg/userOrgApi';

export const isProjectExpired = (project: ProjectModel) => project?.EndDate && new Date(project.EndDate) < new Date();

export const getValuesNotPresent = (
    selectedGlobalFilterValues: string[],
    projects: GetProjectApiResponse | undefined
) => selectedGlobalFilterValues?.filter(shortName => !projects?.some(project => project?.ShortName === shortName));
